import { Button, Card, Row } from 'antd'
import CustomBreadCrumb from 'components/Common/CustomBreadCrumb'
import useFetch from 'elements/Hooks/useFetch'
import PageTitle from 'elements/PageTitle'
import DateCell from 'elements/Table/Cells/DateCell'
import StatusCell from 'elements/Table/Cells/StatusCell'
import CustomTable from 'elements/Table/CustomTable'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'

function SupportTicket() {
  const [fetchClosed, setFetchClosed] = useState(false)

  const { data, fetching, fetch } = useFetch({
    url: fetchClosed ? 'support?includeClosed=true' : 'support',
  })

  const open = data.filter((i) => !['Solved', 'Closed'].includes(i.status))

  const [showAll, setShowAll] = useState(false)

  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      Cell: ({ value, original }) => <Link to={{ pathname: `/support/${original._key}/update` }}>{value}</Link>,
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: DateCell,
    },

    {
      Header: 'Age',
      accessor: 'date',
      Cell: ({ value }) => moment(value).fromNow(),
    },
    {
      Header: 'User',
      accessor: 'member.fn',
    },
    {
      Header: 'Assigned To',
      accessor: 'assignedTo.fn',
    },
    {
      Header: 'Priority',
      accessor: 'priority',
    },
    {
      Header: 'status',
      accessor: 'status',
      Cell: StatusCell,
    },
  ]

  return (
    <div className="space-y-2">
      <Card>
        <Row>
          <CustomBreadCrumb items={[{ text: 'Support Ticketing System' }]} />
          <PageTitle
            title={'Support Ticketing System'}
            subtitle={'Manage Your Customers Support Tickets.'}
            color={'#ff9935'}
            iconType={'fire'}
          />
        </Row>
      </Card>
      <Row>
        <Card>
          <CustomTable
            {...{
              data: showAll ? data : open,
              fetch,
              fetching,
              columns,
              defaultSorted: [{ id: 'date', desc: true }],
              ExtraButtons: () => (
                <Button type={'dashed'} size={'small'} onClick={() => setShowAll((e) => !e)}>
                  {showAll ? 'Only Open' : 'Show All' }
                </Button>
              ),
            }}
          />
        </Card>
      </Row>
    </div>
  )
}

export default SupportTicket
